import React from 'react';
import { useThemeContext } from "../../context/themeContext";

const Card06 = ({ image, title, direction }) => {

    const { themeSetting } = useThemeContext()

    const wrapperStyle = {
        position: 'relative',
        display: 'flex',
        justifyContent: direction == "right" ? 'end' : 'start',
        width: '100%',
        paddingBottom: '133%'
    }

    const style = {
        flexDirection: 'column',
        alignItems: 'center',
        borderRadius: '100 0px',
        position: 'absolute',
        top: '15px',
        left: '15px',
        width: '90%'
    };

    const borderStyle1 = {
        position: "absolute",
        width: '90%',
        height: '90%',
        borderRadius: '100px 0', 
        border: '4px solid transparent', 
        background: `linear-gradient(180deg, ${themeSetting.colors.primary}, transparent) border-box`,
        WebkitMask: 'linear-gradient(#fff 0 0) padding-box,' + 'linear-gradient(#fff 0 0)',
        WebkitMaskComposite: 'xor', /*5'*/
        maskComposite: 'exclude',
    }
    
    const borderStyle2 = {
        position: "absolute",
        width: '90%',
        height: '90%',
        borderRadius: '100px 0', 
        border: '4px solid transparent', 
        background: `linear-gradient(180deg, ${themeSetting.colors.secondary}, transparent) border-box`,
        WebkitMask: 'linear-gradient(#fff 0 0) padding-box,' + 'linear-gradient(#fff 0 0)',
        WebkitMaskComposite: 'xor', /*5'*/
        maskComposite: 'exclude',
        bottom: 0,
        right: 0,
    };

    const titleStyle = {
        position: 'absolute',
        width: '90%',
        height: '22%',
        background: 'linear-gradient(180deg, #3C3C3C 9.9%, rgba(0, 0, 0, 0) 100%)',
        backdropFilter: 'blur(9px)',
        borderRadius: '100px 0px',
        bottom: 0,
        left: '15px',
        fontWeight: 700,
        fontSize: '1.12em',
        padding: '10px',
        paddingRight: '20px',
        textAlign: 'right',
        wordWrap: 'break-word'
    };

    return (
        <div style={wrapperStyle} className='nft-showcase-card-wrapper'>
            <div style={borderStyle1}></div>
            <div style={borderStyle2}></div>
            <img src={image} style={style} alt={title} />
            <div style={titleStyle} className='font-face-pop'>
                {title}
            </div>
        </div>
    );
};

export default Card06;